const cases = {
  casesPage: {
    header: {
      titlePrefix: "Impact",
      titleHighlight: "concret",
      subtitle:
        "Découvrez comment j’aide les organisations à transformer des données complexes en avantages compétitifs via des solutions IA et un accompagnement stratégique.",
    },
    card: {
      resultLabel: "Résultat",
      viewCase: "Voir le cas",
    },
    cta: {
      titlePrefix: "Transformez vos",
      titleHighlight1: "données",
      titleMiddle: "en",
      titleHighlight2: "valeur",
      subtitle:
        "Vous visez des résultats similaires ? Discutons de solutions IA et de stratégies data sur mesure pour accélérer la croissance de votre organisation.",
      primaryButton: "Réserver un échange stratégique",
      secondaryButton: "Envoyer un message",
    },
  },
  caseDetail: {
    technologiesUsed: "Technologies utilisées",
    suggestedTitle: "Vous pourriez aussi aimer",
    viewCase: "Voir le cas",
    footerCta: {
      titlePrefix: "Intéressé par une",
      titleHighlight: "solution similaire ?",
      subtitle:
        "Discutons de la manière d’adapter cette technologie à vos besoins et d’accélérer votre roadmap IA.",
      primaryButton: "Réserver un échange stratégique",
      secondaryButton: "Envoyer un message",
    },
  },
};

export default cases;
